// Terminal routes
export default ['/terminal', '/terminal/sell/:type()'] as string[];
